export default "__VITE_ASSET__D7Dx7dDP__"